import { Component, OnInit, OnDestroy } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';

interface CodigoVerificacion {
  ver_cod_date: string;
  ver_cod_username: string;
  ver_cod_use_id: number;
  ver_cod_function: string;
  ver_cod_sta_id: number;
  ver_cod_code: string;
  ver_cod_email: string;
  use_name: string;
  use_paternal_surname: string;
  use_maternal_surname: string;
  sta_name: string;
  tipo_cod: string;
}

@Component({
  selector: 'app-codigos-verificacion',
  templateUrl: './codigos-verificacion.component.html',
  styleUrls: ['./codigos-verificacion.component.css']
})
export class CodigosVerificacionComponent implements OnInit, OnDestroy {

  usuario: any = {};

  filtro: string = '';

  codigos: CodigoVerificacion[] = [];
  codigosFiltrados: CodigoVerificacion[] = [];

  cargando: boolean = false;
  mensajeError: string = '';

  private intervaloEstado: any;

  constructor(
    public generalServices: GeneralService,
    private encriptacionService: EncriptacionService
  ) { }

  ngOnInit(): void {
    this.usuario = this.encriptacionService.getUserInfo();

    this.listarCodigos();

    // Actualiza visualmente los estados cada 10 segundos
    this.intervaloEstado = setInterval(() => {
      this.codigosFiltrados = [...this.codigosFiltrados];
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.intervaloEstado) {
      clearInterval(this.intervaloEstado);
    }
  }

  async listarCodigos(): Promise<void> {
    this.cargando = true;
    this.mensajeError = '';

    try {
      const response: any = await this.generalServices.postListarCodVerfificacion();

      console.log('[CodigosVerificacion] response:', response);

      if (Array.isArray(response)) {
        this.codigos = response;
      } else if (response && Array.isArray(response.data)) {
        this.codigos = response.data;
      } else {
        this.codigos = [];
      }

      this.ordenarCodigos();

      this.aplicarFiltro();

    } catch (error) {
      console.error('[CodigosVerificacion] Error:', error);

      this.codigos = [];
      this.codigosFiltrados = [];

      this.mensajeError = 'Ocurrió un error al cargar los códigos de verificación.';

    } finally {
      this.cargando = false;
    }
  }

  aplicarFiltro(): void {
    const texto = this.normalizarTexto(this.filtro);

    if (!texto) {
      this.codigosFiltrados = [...this.codigos];
      return;
    }

    this.codigosFiltrados = this.codigos.filter((codigo: CodigoVerificacion) => {

      const valores = [
        codigo.ver_cod_date,
        codigo.ver_cod_username,
        codigo.ver_cod_use_id,
        codigo.ver_cod_function,
        codigo.ver_cod_sta_id,
        codigo.ver_cod_code,
        codigo.ver_cod_email,
        codigo.use_name,
        codigo.use_paternal_surname,
        codigo.use_maternal_surname,
        codigo.sta_name,
        codigo.tipo_cod,
        this.obtenerEstadoCodigo(codigo.ver_cod_date),
        this.obtenerNombreCompleto(codigo)
      ];

      return valores.some(valor =>
        this.normalizarTexto(valor).includes(texto)
      );
    });
  }

  limpiarBusqueda(): void {
    this.filtro = '';
    this.aplicarFiltro();
  }

  obtenerNombreCompleto(codigo: CodigoVerificacion): string {
    return [
      codigo.use_name,
      codigo.use_paternal_surname,
      codigo.use_maternal_surname
    ]
      .filter(valor => !!valor)
      .join(' ');
  }

  obtenerEstadoCodigo(fecha: string): string {
    const fechaCodigo = this.convertirFecha(fecha);

    if (!fechaCodigo) {
      return 'EXPIRADO';
    }

    const ahora = new Date();

    const diferencia = ahora.getTime() - fechaCodigo.getTime();

    const cincoMinutos = 5 * 60 * 1000;

    if (diferencia >= 0 && diferencia <= cincoMinutos) {
      return 'ACTIVO';
    }

    return 'EXPIRADO';
  }

  codigoActivo(fecha: string): boolean {
    return this.obtenerEstadoCodigo(fecha) === 'ACTIVO';
  }

  obtenerTiempoRestante(fecha: string): string {
    const fechaCodigo = this.convertirFecha(fecha);

    if (!fechaCodigo) {
      return '';
    }

    const ahora = new Date();

    const expiracion = fechaCodigo.getTime() + (5 * 60 * 1000);

    const diferencia = expiracion - ahora.getTime();

    if (diferencia <= 0) {
      return '';
    }

    const minutos = Math.floor(diferencia / 60000);
    const segundos = Math.floor((diferencia % 60000) / 1000);

    return minutos + ':' + (segundos < 10 ? '0' + segundos : segundos);
  }

  private convertirFecha(fecha: string): Date | null {
    if (!fecha) {
      return null;
    }

    try {
      // Formato esperado:
      // 06-10-2026 15:49:33

      const partes = fecha.trim().split(' ');

      if (partes.length !== 2) {
        return null;
      }

      const fechaParte = partes[0].split('-');
      const horaParte = partes[1].split(':');

      if (fechaParte.length !== 3 || horaParte.length !== 3) {
        return null;
      }

      const dia = Number(fechaParte[0]);
      const mes = Number(fechaParte[1]) - 1;
      const anio = Number(fechaParte[2]);

      const hora = Number(horaParte[0]);
      const minuto = Number(horaParte[1]);
      const segundo = Number(horaParte[2]);

      const fechaConvertida = new Date(
        anio,
        mes,
        dia,
        hora,
        minuto,
        segundo
      );

      if (isNaN(fechaConvertida.getTime())) {
        return null;
      }

      return fechaConvertida;

    } catch (error) {
      console.error(
        '[CodigosVerificacion] Error convirtiendo fecha:',
        fecha,
        error
      );

      return null;
    }
  }

  private ordenarCodigos(): void {
    this.codigos.sort((a: CodigoVerificacion, b: CodigoVerificacion) => {

      const fechaA = this.convertirFecha(a.ver_cod_date);
      const fechaB = this.convertirFecha(b.ver_cod_date);

      const tiempoA = fechaA ? fechaA.getTime() : 0;
      const tiempoB = fechaB ? fechaB.getTime() : 0;

      return tiempoB - tiempoA;
    });
  }

  private normalizarTexto(valor: any): string {
    if (valor === null || valor === undefined) {
      return '';
    }

    return valor
      .toString()
      .trim()
      .toLowerCase();
  }

  trackByCodigo(
    index: number,
    item: CodigoVerificacion
  ): string {
    return item.ver_cod_code + '_' + item.ver_cod_date + '_' + index;
  }
}